import type { AxiosInstance } from 'axios'
import type { IFactoryFunctionRequest, IFactoryResponse } from '@bc-library/interface'
import { EMethod } from '@bc-library/interface'
import useAxios from '@/services/api/useAxios'
import { API_MAIN_VERSION, BASE_URL } from '@/config/constantes'
import { afterReceiving, beforeSending } from './hooks'

const resource = 'meetings'

const retreiveRecruitmentSlots = (axios: IFactoryFunctionRequest<Array<any>, Array<any>>) => (query): IFactoryResponse<Array<any>, Array<any>> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/retreiveRecruitmentSlots`,
    query,
    afterReceivingHook: afterReceiving,
  })
}

const createMeetingSlot = (axios: IFactoryFunctionRequest<any, any>) => (data): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.post,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}`,
    data,
  })
}

const getMeeting = (axios: IFactoryFunctionRequest<any, any>) => (id: string): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.get,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
    afterReceivingHook: afterReceiving,
  })
}

const updateMeeting = (axios: IFactoryFunctionRequest<any, any>) => (id: string, data): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.put,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/update/${id}`,
    data,
    beforeSendingHook: beforeSending,
    afterReceivingHook: afterReceiving,
  })
}

const deleteMeeting = (axios: IFactoryFunctionRequest<any, any>) => (id: string): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/${id}`,
  })
}

const deleteMeetingSeries = (axios: IFactoryFunctionRequest<any, any>) => (
  slotSeriesId: string,
  query?: { afterDate?: string | Date },
): IFactoryResponse<any, any> => {
  return axios({
    method: EMethod.delete,
    url: `${BASE_URL}/${API_MAIN_VERSION}/${resource}/v2/series/${slotSeriesId}`,
    query,
  })
}

export default (axios: AxiosInstance) => ({
  retreiveRecruitmentSlots: retreiveRecruitmentSlots(useAxios(axios)),
  createMeetingSlot: createMeetingSlot(useAxios(axios)),
  getMeeting: getMeeting(useAxios(axios)),
  updateMeeting: updateMeeting(useAxios(axios)),
  deleteMeeting: deleteMeeting(useAxios(axios)),
  deleteMeetingSeries: deleteMeetingSeries(useAxios(axios)),
})
